import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { fetchTransactionEvents, fetchOpportunitiesForPropertyHistory } from 'store/actions';
import { TabsWrapper, LoadingOverlayWrapper } from 'components/layout';
import TransactionEventHistoryGrid from 'components/underwrite/shared/histories/TransactionEventHistoryGrid';
import PropertyHistoryOpportunitiesGrid from 'components/underwrite/acquisition/propertyUnderwrite/header/propertyHistory/PropertyHistoryOpportunitiesGrid';
import { sendClientLog } from 'services/logService';
import { Constants } from 'utilities/constants';

const PropertyHistory = ({ classes, location, asgPropID, txnOppID, livingAreaSqFt, fetchTransactionEvents, fetchOpportunitiesForPropertyHistory, isFetchingTransactionEvents, isFetchingPropertyHistoryOpportunities }) => {
  const [transactionEvents, setTransactionEvents] = useState(null);
  const [opportunities, setOpportunities] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    fetchOpportunitiesForPropertyHistory(asgPropID, opportunityCallback);

    if (!transactionEvents) {
      fetchTransactionEvents(asgPropID, livingAreaSqFt, txnEventCallback);
    }
    return () => {
      isMounted.current = false;
    }
  }, [asgPropID]);

  const txnEventCallback = (fetchedData) => {
    if (!isMounted.current) return;
    setTransactionEvents(fetchedData);
  }
  const opportunityCallback = fetchedData => {
    if (!isMounted.current) return;
    setOpportunities(fetchedData);
  }

  const eventsLabel = `Transaction Events${transactionEvents?.length ? ` (${transactionEvents.length})` : ''}`;
  const opportunitiesLabel = `Amherst Opportunities${opportunities?.length ? ` (${opportunities.length})` : ''}`;

  const onTabClick = (tabLabel) => {
    if (tabLabel === eventsLabel) {
      sendClientLog('Info', `User clicked Transaction Events tab on Property History for PM ID ${asgPropID}`);
    }
  }
  
  const isUWPage = location.pathname.startsWith(Constants.Routes.UNDERWRITE_PROPERTY);
  return (
    <TabsWrapper defaultTab={isUWPage ? 1 : 0} labels={[eventsLabel, opportunitiesLabel]} onTabClick={onTabClick} style={{ marginBottom: 8 }}>
      <LoadingOverlayWrapper
        active={isFetchingTransactionEvents}
        message={'Fetching transaction events...'}
      >
        <Typography className={classes.title} variant="subtitle2">Transaction events for property including external sources</Typography>
        <TransactionEventHistoryGrid gudTransactionEvents={transactionEvents} />
      </LoadingOverlayWrapper>
      <LoadingOverlayWrapper
        active={isFetchingPropertyHistoryOpportunities}
        message={'Fetching opportunities...'}
      >
        <Typography className={classes.title} variant="subtitle2">History of transaction opportunities in ReVUe</Typography>
        <PropertyHistoryOpportunitiesGrid txnOppID={txnOppID} opportunities={opportunities} />
      </LoadingOverlayWrapper>
    </TabsWrapper>
  );
};

const styles = theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: 5,
    left: 5,
    zIndex: 1,
  },
  title: {
    marginBottom: 8
  }
});

const mapStateToProps = (state) => {
  return {
    isFetchingTransactionEvents: state.propertyUWState.isFetchingTransactionEvents,
    isFetchingPropertyHistoryOpportunities: state.propertyUWState.isFetchingPropertyHistoryOpportunities
  }
};

const mapDispatchToProps = (dispatch) => ({
  fetchTransactionEvents: (asgPropId, livingAreaSqFt, callback) => dispatch(fetchTransactionEvents(asgPropId, livingAreaSqFt, callback)),
  fetchOpportunitiesForPropertyHistory: (asgPropId, callback) => dispatch(fetchOpportunitiesForPropertyHistory(asgPropId, callback))
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyHistory);

